import { render, staticRenderFns } from "./preregistration.vue?vue&type=template&id=1bbee4e6&scoped=true"
import script from "./preregistration.vue?vue&type=script&lang=js"
export * from "./preregistration.vue?vue&type=script&lang=js"
import style0 from "./preregistration.vue?vue&type=style&index=0&id=1bbee4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbee4e6",
  null
  
)

export default component.exports